import {
  IonButton,
  IonContent,
  IonIcon,
  IonInput,
  IonPage,
} from '@ionic/react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';
import { mailOutline, warningOutline } from 'ionicons/icons';
import { ReduxCommandCreator } from 'appRedux/actions';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CasinoNavBar from 'components/CasinoNavBar';
import { onPromise } from '../CreateAccount';
import useToast from 'common/reactHooks/useToast';

interface FormData {
  email: string;
}

const schema = yup.object().shape({
  email: yup.string().email('Email address is not valid').required('Email address is required'),
});

export const EnterpriseForgotPassword = () => {
  const dispatch = useDispatch();
  const commands = ReduxCommandCreator(dispatch);
  const history = useHistory();
  const showToast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: yupResolver(schema) });

  const onSubmit = async (data: FormData) => {
    const email = data.email.trim().toLowerCase();
    setIsSubmitting(true);
    try {
      await Auth.forgotPassword(email);
      commands.SetUserInfo(email, undefined, email);
      history.push('/auth/enterprise-resetpassword');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unable to send reset code';
      showToast({ message, type: 'danger' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <IonPage className="login-v2-page">
      <IonContent fullscreen>
        <div className="login-v2-wrapper">
          <div className="casino-fixed-top__nav login-v2-nav-wrap">
            <CasinoNavBar hideSearch hideLogo hideMenu />
            <button
              className="login-v2-back-btn"
              onClick={() => history.goBack()}
              aria-label="Go back"
            />
          </div>
          <div className="login-v2-bg">
            <div className="login-v2-body">
              <h1 className="login-v2-welcome">FORGOT PASSWORD</h1>
              <div className="login-v2-form">
                <form onSubmit={onPromise(handleSubmit((data) => void onSubmit(data)))}>
                  {/* Email field */}
                  <div className="login-v2-field-wrap login-v2-pass-wrap">
                    <IonIcon icon={mailOutline} className="login-v2-field-prefix-icon" />
                    <div className="login-v2-pass-content">
                      <Controller
                        name="email"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                          <IonInput
                            type="email"
                            placeholder="Enter your email"
                            value={value}
                            onIonChange={(e) => onChange(e.detail.value ?? '')}
                            autocomplete="email"
                          />
                        )}
                        rules={{ required: true }}
                      />
                    </div>
                  </div>
                  {errors.email?.message && (
                    <div className="login-v2-field-error">
                      <IonIcon icon={warningOutline} />
                      <span>{errors.email.message}</span>
                    </div>
                  )}

                  <IonButton
                    type="submit"
                    expand="block"
                    className="login-v2-submit-btn"
                    disabled={isSubmitting}
                  >
                    Send Reset Code
                  </IonButton>
                </form>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};
